import { render, staticRenderFns } from "./ModalAlertChangeSupervisor.vue?vue&type=template&id=1d15ea74&scoped=true&"
import script from "./ModalAlertChangeSupervisor.vue?vue&type=script&lang=js&"
export * from "./ModalAlertChangeSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertChangeSupervisor.vue?vue&type=style&index=0&id=1d15ea74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d15ea74",
  null
  
)

export default component.exports